const formatDiscoveryUpdateDate = (company) => {
    const updateValue = company?.latestDataUpdate || company?.updatedAt;
    if (!updateValue) return 'n/a';

    const updateDate = new Date(updateValue);
    return Number.isNaN(updateDate.getTime()) ? 'n/a' : updateDate.toLocaleDateString();
};

export default formatDiscoveryUpdateDate;
